import { Map } from 'immutable';
import { IpFilter as IpFilterPresenter } from './presenter';
import { screenreaderNotification, connect, getActiveQuiz, setFilterIpAddress, setIpFiltersApi, setIpFiltersUi, featureOn } from '@instructure/quiz-core';
function mapStateToProps(state) {
  var activeQuiz = getActiveQuiz(state);
  var workingInst = activeQuiz.getWorkingInstance();
  return {
    activeQuizId: activeQuiz.id,
    filterIpAddress: workingInst.filterIpAddress,
    filters: workingInst.filters || Map(),
    namedFiltersOn: featureOn('named_ip_filters')
  };
}
var actions = {
  setFilterIpAddress: setFilterIpAddress,
  setIpFiltersApi: setIpFiltersApi,
  setIpFiltersUi: setIpFiltersUi,
  screenreaderNotification: screenreaderNotification
};
export var IpFilter = connect(mapStateToProps, actions)(IpFilterPresenter);
export default IpFilter;